var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 8.99904V16.999M9.5 8.99904V16.999M14.5 8.99904V16.999M19 8.99904V16.999M3 18.599L3 19.399C3 19.9591 3 20.2391 3.10899 20.453C3.20487 20.6412 3.35785 20.7942 3.54601 20.89C3.75992 20.999 4.03995 20.999 4.6 20.999H19.4C19.9601 20.999 20.2401 20.999 20.454 20.8901C20.6422 20.7942 20.7951 20.6412 20.891 20.453C21 20.2391 21 19.9591 21 19.399V18.599C21 18.039 21 17.759 20.891 17.5451C20.7951 17.3569 20.6422 17.2039 20.454 17.108C20.2401 16.999 19.9601 16.999 19.4 16.999H4.6C4.03995 16.999 3.75992 16.999 3.54601 17.108C3.35785 17.2039 3.20487 17.3569 3.10899 17.5451C3 17.759 3 18.039 3 18.599ZM11.6529 3.07617L4.25291 4.72062C3.80585 4.81997 3.58232 4.86964 3.41546 4.98985C3.26829 5.09588 3.15273 5.23994 3.08115 5.40661C3 5.59557 3 5.82455 3 6.28252L3 7.39904C3 7.9591 3 8.23912 3.10899 8.45303C3.20487 8.6412 3.35785 8.79418 3.54601 8.89005C3.75992 8.99904 4.03995 8.99904 4.6 8.99904H19.4C19.9601 8.99904 20.2401 8.99904 20.454 8.89005C20.6422 8.79418 20.7951 8.6412 20.891 8.45303C21 8.23912 21 7.9591 21 7.39904V6.28252C21 5.82455 21 5.59557 20.9188 5.40661C20.8473 5.23994 20.7317 5.09588 20.5845 4.98985C20.4177 4.86964 20.1942 4.81997 19.7471 4.72062L12.3471 3.07617C12.2176 3.04739 12.1528 3.033 12.0874 3.02726C12.0292 3.02216 11.9708 3.02216 11.9126 3.02726C11.8472 3.033 11.7824 3.04739 11.6529 3.07617Z",
    stroke: "#007ED9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.4bc553bafefd5fc891f27e5a2010b6bb.svg";
export { ForwardRef as ReactComponent };